import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Skeleton } from 'shared/ui/Skeleton';
import { Typography } from 'shared/ui/Typography';

import { HeaderStyled } from './styled';

export const MobileHeaderSkeleton = () => (
  <HeaderStyled>
    <Box display='flex' alignItems='center' justifyContent='space-between'>
      <Typography fontSize={theme.fontSizes[36]} fontWeight={theme.fontWeights.extraBold} color={theme.colors.black}>
        <Skeleton width='250px' />
      </Typography>
    </Box>
  </HeaderStyled>
);
